import { View, Text, TouchableOpacity, Image, Dimensions, StyleSheet } from 'react-native'
import theme from '../../../theme'

const { width, height } = Dimensions.get('window')

const styless = StyleSheet.create({
    container: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
    },
    containerFlex: {
        flex: 1,
    },
    viewHeight: {
        height: 70,
    },
    viewHeight2: {
        height: 80,
    },
    image: {
        width: 140,
        height: 140,
    },
    title: {
        fontSize: 20,
        fontWeight: 'bold',
        color: theme.colors.textPrimary,
        textAlign: 'center',
        marginBottom: 6,
    },
    description: {
        fontSize: 17,
        fontWeight: 'normal',
        color: theme.colors.textSecondary,
        textAlign: 'center',
        lineHeight: 23,
        paddingHorizontal: 40,
    },
    containerFilters: {
        flexDirection: 'row',
        backgroundColor: theme.colors.filtersBackground,
        paddingVertical: 6,
    },
    scrollView: {
        flexDirection: 'row',
        flexGrow: 0,
    },
    containerPostFlags: {
        flexDirection: 'row',
        marginHorizontal: 6,
    },
    viewLabels: {
        backgroundColor: 'white',
        height: 40,
        justifyContent: 'space-between',
        flexDirection: 'row',
        alignItems: 'baseline',
        marginTop: 80,
    },
    spacer: {
        marginBottom: 140,
    },
    spacerBis: {
        marginTop: 175,
    },
})

export default styless
